export const NON_US_INDICES = [
  'Nikkei 225',
  'FTSE 100',
  'Euro Stoxx 50',
  'Nifty 50',
  'JPX Prime',
  'JPX Growth',
  'JPX Standard',
  'Macro DM',
  'Macro EM',
  'G7 FX',
];

type GetFilteredAssetIndicesProps<T extends { name: string }> = {
  data?: T[];
};

export const getFilteredAssetIndices = <T extends { name: string }>({
  data,
}: GetFilteredAssetIndicesProps<T>) => {
  if (!data?.length) {
    return [];
  }

  return data;
};
